import { render, staticRenderFns } from "./Communities.vue?vue&type=template&id=7785b6ae&scoped=true"
import script from "./Communities.vue?vue&type=script&lang=js"
export * from "./Communities.vue?vue&type=script&lang=js"
import style0 from "./Communities.vue?vue&type=style&index=0&id=7785b6ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7785b6ae",
  null
  
)

export default component.exports